import {
  Button,
  CloseButton,
  Flex,
  Heading,
  RadioInput,
  RadioInputGroup,
  Tray,
  View,
} from "@instructure/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const FilterTray = ({
  filters,
  setFilters,
  prevFilters,
  setPrevFilters,
  setTriggerMap,
}) => {
  const { t } = useTranslation();
  const [openTray, setOpenTray] = useState(false);

  const handleModeTypeChange = (event) => {
    setFilters((prevFilters) => ({ ...prevFilters, mode: event.target.value }));
  };

  const handleResultsTypeChange = (event) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      masteryResults: event.target.value,
    }));
  };

  const handleUpdateGraphs = () => {
    if (
      prevFilters.mode !== filters.mode ||
      prevFilters.masteryResults !== filters.masteryResults
    ) {
      setTriggerMap((prevTriggerMap) => !prevTriggerMap);
      setPrevFilters((prevFilters) => ({
        ...prevFilters,
        mode: filters.mode,
        masteryResults: filters.masteryResults,
      }));
    }
  };

  return (
    <>
      <Button
        size="small"
        onClick={() => setOpenTray((prevOpenTray) => !prevOpenTray)}
      >
        {openTray ? t("results.hide") : t("results.show")}{" "}
        {t("results.filters")}
      </Button>
      <Tray
        label={t("results.filters")}
        open={openTray}
        size="small"
        placement="end"
      >
        <View as="div" padding="small">
          <Flex>
            <Flex.Item shouldGrow shouldShrink>
              <Heading as="h3" level="h3" border="bottom" margin="0 0 small 0">
                {t("results.filters")}
              </Heading>
            </Flex.Item>
            <Flex.Item>
              <CloseButton
                placement="end"
                offset="small"
                screenReaderLabel={t("global.close")}
                onClick={() => setOpenTray(false)}
              />
            </Flex.Item>
          </Flex>
          <Flex wrap="wrap" padding="small" gap="small">
            <Flex.Item shouldGrow>
              <RadioInputGroup
                size="small"
                layout="columns"
                name="resultsMode"
                defaultValue={filters.mode ? filters.mode : "term"}
                description={`${t("results.displayResultsBy")}:`}
                onChange={handleModeTypeChange}
              >
                <RadioInput
                  value="term"
                  label={t("results.resultsModeByTerm")}
                />
                <RadioInput
                  value="course"
                  label={t("results.resultsModeByCourse")}
                />
              </RadioInputGroup>
            </Flex.Item>
            <Flex.Item shouldGrow>
              <RadioInputGroup
                size="small"
                layout="columns"
                name="resultsType"
                defaultValue={
                  filters.masteryResults ? filters.masteryResults : "true"
                }
                onChange={handleResultsTypeChange}
                description={`${t("results.viewResultsBy")}:`}
              >
                <RadioInput value="true" label={t("results.modeMasteryAvg")} />
                <RadioInput value="false" label={t("results.modeGradeAvg")} />
              </RadioInputGroup>
            </Flex.Item>
            <Flex.Item shouldGrow padding="0 small" textAlign="end">
              <Button size="small" color="primary" onClick={handleUpdateGraphs}>
                {t("results.updateGraphs")}
              </Button>
            </Flex.Item>
          </Flex>
        </View>
      </Tray>
    </>
  );
};

export default FilterTray;
